import RobotAmazing from "../assets/pictures/robot_amazing.png";
import "../styles/robot.css";

export default function CorrectAnswer() {
  return (
    <>
      <img src={RobotAmazing} className="robot" alt="Animation error"></img>
    </>
  );
}
